import React from 'react';
import styled from 'styled-components';
import Element from './element';
import Wrapper from './wrapper';
import Icon from './icon';

const Radio = ({
  className,
  Tag,
  ...other
}) => (
  <Wrapper as={Tag} className={className}>
    <Element {...other} />
    <Icon />
  </Wrapper>
);

export default styled(Radio)``;
